import { useTemplateRef as $, openBlock as s, createBlock as n, Transition as T, withCtx as a, withDirectives as w, createElementVNode as B, normalizeClass as c, createElementBlock as l, Fragment as v, renderList as L, withModifiers as d, withKeys as x, createVNode as f, mergeProps as C, createCommentVNode as m, toDisplayString as h, renderSlot as D, vShow as S } from "vue";
import { themeProp as z } from "../../../composables/useTheme.js";
import y from "../../../atoms/icon/icon.vue.js";
import p from "../../../atoms/icon/icon-frame.vue.js";
/* empty css                     */
const K = ["id", "tabindex", "aria-disabled", "onClick", "onKeydown"], M = ["innerHTML"], N = { key: 2 }, V = {
  key: 3,
  class: "select-box-list__item__additional-text ds-text-small color-grey-1900"
}, I = /* @__PURE__ */ Object.assign({
  name: "DsSelectBoxList"
}, {
  __name: "select-box-list",
  props: {
    ...z,
    opened: {
      type: Boolean,
      required: !0
    },
    options: {
      type: Array,
      required: !0
    }
  },
  emits: ["select", "close"],
  setup(r, { emit: g }) {
    const _ = g, o = $("ulBoxList"), b = (t) => {
      var i;
      t != null && t.disabled || ((i = o.value) != null && i.$el && (o.value.$el.scrollTop = 0), _("select", t));
    };
    return (t, i) => (s(), n(T, {
      name: "select-box-list__transition",
      appear: ""
    }, {
      default: a(() => [
        w(B("ul", {
          ref_key: "ulBoxList",
          ref: o,
          role: "listbox",
          class: c([`ds-popover-container--${t.theme}`, "select-box-list ds-popover-container"])
        }, [
          (s(!0), l(v, null, L(r.options, (e, k) => (s(), l("li", {
            id: `${t.$attrs.id}-${k}`,
            key: e.id,
            role: "option",
            tabindex: r.opened ? 0 : -1,
            "aria-disabled": e.disabled,
            class: c(["select-box-list__item ds-button-list-option", [
              `ds-button-list-option--${t.theme}`,
              { "select-box-list__item--selected": e.selected },
              { "select-box-list__item--with-icon": e.icon },
              { "select-box-list__item--disabled": e.disabled }
            ]]),
            "data-j-select-box-list": "",
            onClick: d((u) => b(e), ["prevent"]),
            onKeydown: [
              x(d((u) => b(e), ["prevent"]), ["enter"]),
              i[0] || (i[0] = x(d((u) => _("close"), ["prevent"]), ["tab"]))
            ]
          }, [
            e.icon ? (s(), n(p, {
              key: 0,
              size: "24",
              "align-y": "center",
              class: c(["select-box-list__item__icon ds-margin-right-12", { "select-box-list__item__icon--disabled": e.disabled }])
            }, {
              default: a(() => [
                f(y, C({ ref_for: !0 }, e.icon), null, 16)
              ]),
              _: 2
            }, 1032, ["class"])) : m("", !0),
            e.highlightedText ? (s(), l("span", {
              key: 1,
              innerHTML: e.highlightedText
            }, null, 8, M)) : (s(), l("span", N, h(e.text), 1)),
            e.additionalText ? (s(), l("span", V, h(e.additionalText), 1)) : m("", !0),
            e.selected ? (s(), n(p, {
              key: 4,
              size: "24",
              "align-y": "center",
              class: "select-box-list__item__cross"
            }, {
              default: a(() => [
                f(y, {
                  class: "ds-color-grey-500",
                  category: "interface",
                  name: "cross-circle-fill"
                })
              ]),
              _: 1
            })) : m("", !0)
          ], 42, K))), 128)),
          D(t.$slots, "default")
        ], 2), [
          [S, r.opened]
        ])
      ]),
      _: 3
    }));
  }
});
export {
  I as default
};
